import ls from 'localstorage-slim'
import { Suspense, lazy } from 'react'

import { Theme } from '@ankor-io/common/types/account'

import { Dropdown, DropdownButton, DropdownMenu } from '@/ui-components/Dropdown'

// Lazy load emoji picker as it is heavy and may affect initial modal load
const EmojiPickerReact = lazy(() => import('emoji-picker-react'))

type EmojiPickerProps = {
  categoryIcon: string
  setEmoji: (value: string) => void
}

const EmojiPicker = ({ categoryIcon, setEmoji }: EmojiPickerProps) => {
  return (
    <Dropdown>
      {({ open, close }) => (
        <div>
          <DropdownButton
            color="light"
            className="!max-w-56"
          >
            {categoryIcon ? <span>Selected icon: {categoryIcon}</span> : <span>Pick an icon</span>}
          </DropdownButton>
          {open ? (
            <DropdownMenu
              anchor="top start"
              className="z-50 !grid-cols-1 !p-0"
            >
              <Suspense fallback={<div className="p-4 text-sm text-gray-500 dark:text-gray-400">Loading icons…</div>}>
                <EmojiPickerReact
                  lazyLoadEmojis
                  skinTonesDisabled
                  height={400}
                  searchPlaceHolder="Search emoji…"
                  theme={ls.get('prefers-color-scheme') === Theme.DARK ? Theme.DARK : Theme.LIGHT}
                  onEmojiClick={(emoji) => {
                    setEmoji(emoji.emoji)
                    close()
                  }}
                />
              </Suspense>
            </DropdownMenu>
          ) : null}
        </div>
      )}
    </Dropdown>
  )
}

export default EmojiPicker
